import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`
const Icon = styled.i`
  border-radius: 50%;
  background: ${props => props.color ? props.color : '#ce7019'};
  font-size: ${props => props.fontSize ? props.fontSize : '13pt'}; 
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props.height ? props.height : '35px'};
  width: ${props => props.width ? props.width : '35px'};
  font-style: normal;
  ${props => props.loading ? `animation: ${spin} 1s linear infinite;` : ''}
`
export default props => {
  return (
    <Icon
      loading={props.loading}
      className={props.loading ? 'fa fa-circle-o-notch' : props.className}
      color={props.color}
      fontSize={props.fontSize}
      height={props.height}
      width={props.width}
    >{!props.loading ? props.children : null}</Icon>
  )
}
